/* 
Scaffolded code: this code was scaffolded by the code generator, feel free to change it
Template: ViewModel.cst
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { QueryOptions } from 'src/store/fetch-services';
import { VehicleMakeEntityFetchService } from 'src/store/generated/client-sync.generated';
import {
  VehicleMakeProps,
  VehicleMakeViewModelBase,
} from 'src/store/generated/vehicle-make-record.generated';

export class VehicleMakeViewModel extends VehicleMakeViewModelBase {
  constructor(props: VehicleMakeProps) {
    super(props);
  }
}

@Injectable({ providedIn: 'root' })
export class VehicleMakeViewModelService {
  constructor(private readonly _vehicleMakeEntityFetchService: VehicleMakeEntityFetchService) {}

  public getById(id: string, options?: QueryOptions): Observable<VehicleMakeViewModel | undefined> {
    return this._vehicleMakeEntityFetchService.getById(id, options).pipe(
      map((vehicleMake) => {
        if (vehicleMake == null) {
          return undefined;
        }
        return new VehicleMakeViewModel(vehicleMake);
      }),
    );
  }
}
